// import moment from "moment";
// import Dialog from '../common/dialog.vue'
// import * as DataUtil from "../../util/DataUtil";

// import { Loading } from 'element-ui';
// var loadingInstance = Loading.service({ fullscreen: true });
// import {
//   formatMoney,
//   monthEnd,
//   monthStart,
//   traverseObj,
//   weekEnd,
//   weekStart,
//   parseUrlParams
// } from "../../util/DataUtil";
import Vue from "vue";

// import _ from "lodash";
// var loadingInstance = null
function utils() {
    Vue.prototype.bxDeepClone=function(obj) {
        if (obj == null) return null;
        let newObj = obj instanceof Array ? [] : {};
        for (var i in obj) {
            newObj[i] = typeof obj[i] === "object" ? this.bxDeepClone(obj[i]) : obj[i];
        }
        return newObj;
    }
    Vue.prototype.onSearch = function(e){
        let url = `/policy`
        // ?${e.name}=${encodeURIComponent(e.value)}
        if(e && e.length > 0){
            url = url + '?'
            for(let search of e){
                console.log(url.indexOf('?'),url.length)
                if(url.indexOf('?') == url.length - 1){
                    url = `${url}&${search.name}=${encodeURIComponent(search.value)}`
                }
                
            }
            this.$router.push({
                path:`${url}`
            })
        }else{

        }
        
        console.log(e)
    }
    Vue.prototype.reHtmlImgSrc = function (str){
        var data = [];
            str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, function (match, capture) {
                  data.push(capture);
            });
            // console.log(data)
        return data
    }
}

export default utils;
